import type { BlocksContent } from '@strapi/blocks-react-renderer';

/**
 * Narrows a Strapi `blocks` field to what `RichText` renders.
 *
 * The generated DTOs type these fields as an open record array — `blocks` has
 * no OpenAPI shape, and typing it as an object generates
 * `Record<string, never>`, which rejects the real payload. Validating the node
 * tree at runtime would buy nothing: Strapi owns it and the renderer already
 * ignores nodes it does not know. So the assertion lives here, once, instead of
 * at every call site.
 */
export function toBlocksContent(
  value: Record<string, unknown>[] | null | undefined,
): BlocksContent | undefined {
  return (value as BlocksContent | null) ?? undefined;
}
